var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.$store.getters.currentRoomType
        ? [
            _vm.$store.getters.currentRoomType.DISPLAY?.ROOM_ADA
              ? [
                  false !==
                  _vm.isRoomTypeVariantExists(
                    "ROOM_ADA",
                    true,
                    _vm.$store.state.currentPrtId
                  )
                    ? _c(
                        "a",
                        {
                          attrs: { title: "Click to Change", href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$store.commit("updateState", [
                                "isVariantDialogVisible",
                                true,
                              ])
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$store.getters.currentRoomType.DISPLAY
                                  .ROOM_ADA_VARIANT
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$store.getters.currentRoomType.DISPLAY
                                .ROOM_ADA_VARIANT
                            ) +
                            "\n      "
                        ),
                      ],
                ]
              : [
                  false !==
                  _vm.isRoomTypeVariantExists(
                    "ROOM_ADA",
                    true,
                    _vm.$store.state.currentPrtId
                  )
                    ? _c(
                        "a",
                        {
                          attrs: {
                            title: "Click to See Accessible Room Options",
                            href: "#",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$store.commit("updateState", [
                                "isVariantDialogVisible",
                                true,
                              ])
                            },
                          },
                        },
                        [_vm._v("Available")]
                      )
                    : _vm._e(),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }